(function () {
  var STORAGE_KEY = 'rof-yard-entered-v1';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function tick(root) {
    var iso = root.getAttribute('data-end-iso') || '';
    var endMs = Date.parse(iso);
    if (!endMs || Number.isNaN(endMs)) return;
    var diff = Math.max(0, endMs - Date.now());
    var totalSec = Math.floor(diff / 1000);
    var d = root.querySelector('[data-cd-d]');
    var h = root.querySelector('[data-cd-h]');
    var m = root.querySelector('[data-cd-m]');
    var s = root.querySelector('[data-cd-s]');
    if (d) d.textContent = pad(Math.floor(totalSec / 86400));
    if (h) h.textContent = pad(Math.floor((totalSec % 86400) / 3600));
    if (m) m.textContent = pad(Math.floor((totalSec % 3600) / 60));
    if (s) s.textContent = pad(totalSec % 60);
  }

  function initCountdown(root) {
    if (!root || root.dataset.rofCdInit === '1') return;
    root.dataset.rofCdInit = '1';
    tick(root);
    window.setInterval(function () {
      tick(root);
    }, 1000);
  }

  function setState(yard, state) {
    yard.classList.remove('is-sealed', 'is-opening', 'is-playing', 'is-ended');
    yard.classList.add(state);
    yard.setAttribute('data-yard-state', state.replace('is-', ''));
  }

  function syncMute(video, muteBtn, muteOn, muteOff) {
    if (!video) return;
    if (muteOn) muteOn.hidden = !video.muted;
    if (muteOff) muteOff.hidden = video.muted;
    if (muteBtn) muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
  }

  function playFilm(yard, video, withSound, muteBtn, muteOn, muteOff) {
    if (!video) return Promise.resolve();
    try {
      video.currentTime = 0;
    } catch (e) {}
    video.muted = !withSound;
    syncMute(video, muteBtn, muteOn, muteOff);
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      return playPromise.catch(function () {
        video.muted = true;
        syncMute(video, muteBtn, muteOn, muteOff);
        return video.play();
      });
    }
    return Promise.resolve();
  }

  function enterYard(yard, video, skipGate, muteBtn, muteOn, muteOff) {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch (e) {}

    var reduce = prefersReducedMotion() || skipGate;
    if (reduce) {
      setState(yard, 'is-playing');
      playFilm(yard, video, true, muteBtn, muteOn, muteOff);
      return;
    }

    setState(yard, 'is-opening');
    window.setTimeout(function () {
      setState(yard, 'is-playing');
      playFilm(yard, video, true, muteBtn, muteOn, muteOff);
    }, 720);
  }

  function bindModal(yard) {
    var modal = yard.querySelector('[data-rof-yard-modal]');
    if (!modal || modal.dataset.bound === '1') return;
    modal.dataset.bound = '1';

    function open() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      var input = modal.querySelector('.rof-yard-modal__input');
      if (input) input.focus();
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      var formView = modal.querySelector('[data-rof-yard-form-view]');
      var successView = modal.querySelector('[data-rof-yard-success-view]');
      if (formView) formView.hidden = false;
      if (successView) successView.hidden = true;
    }

    yard.querySelectorAll('[data-rof-yard-early]').forEach(function (btn) {
      btn.addEventListener('click', open);
    });
    modal.querySelectorAll('[data-rof-yard-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });

    var form = modal.querySelector('.rof-yard-modal__form');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var submitBtn = form.querySelector('.rof-yard-modal__submit');
      var err = modal.querySelector('[data-rof-yard-error]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      if (submitBtn) submitBtn.disabled = true;
      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          if (!res.ok) throw new Error('fail');
          return res.json();
        })
        .then(function (data) {
          if (data && data.errors) {
            if (err) {
              err.textContent =
                (data.errors.email && data.errors.email[0]) || 'Please check your email and try again.';
              err.hidden = false;
            }
            return;
          }
          modal.querySelector('[data-rof-yard-form-view]').hidden = true;
          modal.querySelector('[data-rof-yard-success-view]').hidden = false;
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function initYard(yard) {
    if (!yard || yard.dataset.init === '1') return;
    yard.dataset.init = '1';

    var video = yard.querySelector('[data-rof-yard-video]');
    var muteBtn = yard.querySelector('[data-rof-yard-mute]');
    var muteOn = yard.querySelector('[data-mute-on]');
    var muteOff = yard.querySelector('[data-mute-off]');
    var cd = yard.querySelector('[data-rof-yard-countdown]');
    if (cd) initCountdown(cd);
    bindModal(yard);

    var seen = false;
    try {
      seen = window.localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {}

    if (seen) {
      yard.classList.add('is-return');
      setState(yard, 'is-ended');
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    } else {
      setState(yard, 'is-sealed');
    }

    yard.querySelectorAll('[data-rof-yard-enter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        enterYard(
          yard,
          video,
          prefersReducedMotion() || yard.classList.contains('is-return'),
          muteBtn,
          muteOn,
          muteOff
        );
      });
    });

    if (video) {
      video.addEventListener('ended', function () {
        setState(yard, 'is-ended');
      });
    }

    if (muteBtn && video) {
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        syncMute(video, muteBtn, muteOn, muteOff);
      });
    }
  }

  document.querySelectorAll('[data-rof-yard]').forEach(initYard);
})();
